// PATH: src/components/ui/TemplateDownload.tsx
import * as React from "react";
import { Button } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

/** Les modèles sont des fichiers statiques de `public/modeles/` : des exemples valides. */
export const templateUrl = (file: string) => `${process.env.PUBLIC_URL || ""}/modeles/${file}`;

interface Props {
  /** Fichier de `public/modeles/`. */
  file: string;
  children: React.ReactNode;
}

/** Bouton « télécharger le modèle » : un exemple à recopier, accepté tel quel par le serveur. */
export const TemplateDownload: React.FC<Props> = ({ file, children }) => (
  <Button
    size="small"
    variant="outlined"
    component="a"
    href={templateUrl(file)}
    download={file}
    startIcon={<FileDownloadOutlinedIcon fontSize="small" />}
  >
    {children}
  </Button>
);

export default TemplateDownload;
